import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';
import { ActualiteApiService } from '../../../web-api-services/actualite.service';
import { ActualiteModel } from '../../../models/ActualiteModel';
import { ActualiteService } from '../actualite.service';
import { UtilisateurAngular } from '../../../models/UtilisateurAngular';

@Component({
  selector: 'actualite-carousel',
  templateUrl: './actualite-carousel.component.html',
  styleUrls: ['./actualite-carousel.component.css'],
})
export class ActualiteCarouselComponent implements OnInit {
  @Input() badgeInfo: string = 'Autres actualités';
  @Input() displayAucuneActualite: boolean = false;
  @Input() spliceFirst: boolean = true;

  user: UtilisateurAngular;
  actualites: ActualiteModel[] = [];
  actualitesLoaded: boolean = false;

  constructor(
    private actualiteApiService: ActualiteApiService,
    public actualiteService: ActualiteService,
  ) {}

  ngOnInit() {
    this.loadActualites();
  }

  loadActualites() {
    this.actualiteApiService.getActualitesUser(0).subscribe(actualites => {
      if (this.spliceFirst) {
        actualites.splice(0, 1);
      }
      this.actualites = actualites;
      this.actualitesLoaded = true;
    });
  }
}
